// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!./~/vue-style-loader!./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-38692506","scoped":false,"hasInlineConfig":true}!./~/sass-loader/lib/loader.js?sourceMap!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/elements/RecordsTable.vue
// module id = 268
// module chunks = 0